<template>
  <AlertModal
    :visible="modal.visible"
    :title="modal.title"
    :message="modal.message"
    type="info"
    @close="fecharModal"
  />
</template>

<script>
import AlertModal from '@/componentesTelas/AlertModal.vue';
import { setSessionId, setUsuario } from '@/utils/authStorage';

export default {
  name: "CheckoutSucesso",
  components: { AlertModal },

  data() {
    return {
      modal: {
        visible: true,
        title: "Criando conta",
        message: "Estamos confirmando seu cadastro com a Stripe."
      }
    };
  },

  methods: {
    fecharModal() {
      this.$router.replace('/app');
    }
  },

  async mounted() {
    const sessionId = this.$route.query.session_id;

    if (!sessionId) {
      this.$router.replace("/create-account");
      return;
    }

    try {
      const response = await fetch(`${process.env.VUE_APP_BACKEND_URL}/finalizar-cadastro`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId })
      });

      if (!response.ok) {
        throw new Error("Não foi possível confirmar o cadastro.");
      }

      const data = await response.json();

      setUsuario({
        nome: data.nome,
        email: data.email,
        tipo: data.tipo
      });
      setSessionId(data.sessionId);
      this.$router.replace('/app');
    } catch (error) {
      console.error("Erro ao finalizar cadastro:", error);
      this.$router.replace({
        path: "/create-account",
        query: { checkout: "erro" }
      });
    }
  }
};
</script>